import { useState, useEffect } from "react";

// Boolean-Toggle, der seinen Zustand pro Nutzer in localStorage merkt.
export function usePersistentToggle(key, initial = false) {
    const [val, setVal] = useState(() => {
        try {
            const v = localStorage.getItem(key);
            return v === null ? initial : v === "1";
        } catch {
            return initial;
        }
    });
    useEffect(() => {
        try { localStorage.setItem(key, val ? "1" : "0"); } catch { /* ignore */ }
    }, [key, val]);
    return [val, setVal];
}
